export default __webpack_public_path__ + "static/media/avatar.e14b935c.jpeg";